export var Reports = [
    {
        id: 0,
        label: 'Participation',
        isChecked: false
    },
    {
        id: 1,
        label: 'Bidding Report',
        isChecked: false
    },
    {
        id: 2,
        label: 'Completed Trades',
        isChecked: false
    }
]
